import { Box, CardContent, CardMedia, Typography } from '@mui/material';
import React from 'react';
import { Layout09Styles } from '../../styles/layout_09';
import { GeneralContentProps } from '../../interfaces/generalContentProps';
import { appendCdnToImagePath } from '../../../common/utils/appendCdnToImagePath';
import ReactHtmlParser from 'html-react-parser';
import clsx from 'clsx';
import { GeneralContentStyles } from '../../styles/generalContent';
import { cardsColorPallete } from '../../constants/constants';

const GeneralContentLayout9 = (props: GeneralContentProps): React.JSX.Element => {
  const { titleColor, title, items, backgroundImageEnabled, backgroundColor, id } = props;
  const backgroundImage = props.backgroundImage && {
    ...props.backgroundImage,
    path: appendCdnToImagePath(props.backgroundImage.path),
  };
  const { classes } = GeneralContentStyles({
    backgroundColor,
    backgroundImage: backgroundImage?.path,
    titleColor,
  });
  const { classes: layout09Classes } = Layout09Styles({ ...props, backgroundImage });

  return (
    <Box
      className={clsx({
        [classes.eventContainer]: true,
        [classes.backgroundImage]: backgroundImageEnabled,
        [classes.bgColorContainer]: !backgroundImageEnabled,
      })}
      id={id}>
      <Box>
        <Typography className={classes.title}>{title}</Typography>
      </Box>

      <Box className={layout09Classes.tileGrid}>
        {items &&
          items.map((item, index) => {
            return (
              <Box key={item.title}>
                <div className={layout09Classes.tileCard}>
                  {item.mediaUrl ? (
                    <CardMedia
                      component="img"
                      alt={item.mediaUrl.name}
                      className={layout09Classes.tileHeader}
                      image={appendCdnToImagePath(item.mediaUrl.path)}
                    />
                  ) : (
                    <Box
                      className={layout09Classes.tileHeader}
                      style={{ backgroundColor: `${cardsColorPallete[index]}` }}></Box>
                  )}
                  <CardContent className={layout09Classes.tileDescription}>
                    <Box pb={1.5} textAlign="center">
                      <Typography color="inherit" className={layout09Classes.cardTitle}>
                        {item.title}
                      </Typography>
                    </Box>
                    {item.description && (
                      <Typography variant="body2" component="p" color="inherit">
                        {ReactHtmlParser(item.description)}
                      </Typography>
                    )}
                  </CardContent>
                </div>
              </Box>
            );
          })}
      </Box>
    </Box>
  );
};

export default GeneralContentLayout9;
